import { FieldsContainerProps } from './types';
import * as S from './styles';

const FieldsContainer = (props: FieldsContainerProps): JSX.Element => <S.Container {...props} />;

export default FieldsContainer;
